import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";


export default function Footer() {
    const currentYear = new Date().getFullYear();
    return(
        <footer className='w-footer'>
            <Container>
                <Row className='align-items-center g-sm-4 g-3'>
                    <Col md={6}>
                        <div className='footer-content'>
                            <h3>GPS Area Measure - FieldCalc?</h3>
                            <p>Measure distances, plan routes, capture location photos, and sync data in real-time for easy access.</p>
                            <ul>
                                <li><a href='https://www.instagram.com/fieldcalcapp/' target='_blank' className="ins"><img src="/social/ins.svg" className="img-fluid" alt="Instgram"/></a></li>
                                {/* <li><a href='https://in.pinterest.com/secretphotovault/' target='_blank' className="pin"><img src="/social/pin.svg" className="img-fluid" alt="Pinterest"/></a></li> */}
                                <li><a href='https://www.facebook.com/profile.php?id=100095082746103' target='_blank' className="fb"><img src="/social/fb.svg" className="img-fluid" alt="Facebook"/></a></li>
                                <li><a href='https://www.youtube.com/@fieldcalcapp' target='_blank' className="yt"><img src="/social/yt.svg" className="img-fluid" alt="Youtube"/></a></li>
                                {/* <li><a href='https://x.com/secretvault24' target='_blank' className="x"><img src="/social/x.svg" className="img-fluid" alt="Youtube"/></a></li> */}
                                {/* <li><a href='https://www.tiktok.com/@secretphotovault' target='_blank' className="tik"><img src="/social/tik.svg" className="img-fluid" alt="Tiktok"/></a></li> */}
                            </ul>
                        </div>
                    </Col>
                    <Col md={6}>
                        <div className='footer-app-btn'>
                            <Link className="me-2" to="https://play.google.com/store/apps/details?id=com.voice.gps.navigation.map.location.route&hl=en_IN" target='_blank'><img src='/footer/playstore.svg' alt='PlayStore' className='img-fluid'/></Link>
                            <Link className="ms-2" to="https://apps.apple.com/us/app/gps-fields-area-measure-on-map/id1238984272" target='_blank'><img src='/footer/appstore.svg' alt='AppStore' className='img-fluid'/></Link>
                        </div>
                    </Col>
                    <Col xs={12}>
                        <div className="copyright">
                            <ul>
                                <li><Link to="/privacy-policy" target='_blank'>Privacy Policy</Link></li>
                                <li><Link to="/terms-of-use" target='_blank'>Terms and Condition</Link></li>
                            </ul>
                            <p className='footer-copyright'>All rights reserved ©{currentYear} <span> GPS Area Measure - FieldCalc</span></p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </footer>
)}